import { Time } from '@angular/common';
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import * as TimeSpan from 'timespan';

export interface StockListParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}
export interface StockLists {
 id: number ;
 brancH_TYPE:any;
 brancH_ID:any;
 pharmacY_ID: number ;
 medicinE_ID:any;
 batch:any;
 exp_date:any;
 units_strips: number ;
 sell_mrp:any;
 cp:any;
 mrp:any;
 igst_per:any;
 cgst_per:any;
 sgst_per:any;
 gst_total_per:any;
 pur: number ;
 puR_RTN: number ;
 sal: number ;
 saL_RTN: number ;
 stK_PLUS: number ;
 stK_MINUS: number ;
 stK_OPEN: number ;
 stock_In: number ;
 stock_Out: number ;
 balance: number ;
}

export interface StockListCreate {
  id?: string;
  medicineID:string;
  batchNumber:string;
  expiryDate: Date ;
  pricePerStrips:number;
  sellPriceStrip:number;
  mrpPerStrip:number;
  gstTotalPer: number ;
  referenceNo:string;
  referenceDate:Date;
  stockType:string;
  stockIn:number;
  stockOut:number;
  createdBy:any;
  createdDate:any;
  tenantId: string ;
  branchId: string ;
  branchType: string ;
  pharmacyId: number ;
  unitCostPrice: number ;
  unitSellPrice: number ;
  unitMrpPrice: number ; 
  warehouseId:any;
  pharmcyCounterId:number;

  //New Column(Thenmozhi)
  createdIP:string;

 }

 
export interface StockAdjustmentCreate {
  id?: any;
  adjustmentDate:Date;
  medicineId:string;
  batchNo: string ;
  expDate:Date;
  adjustmentReson:string;
  stockAdjustmentReason?:any;
  adjustmentType:string;
  adjustmentNotes: string ;
  previousData:number;
  newData:number;
  createdBy:any;
  createdDate:Date;
  pharmacyId:number;
  tenantId: string ;
  branchId: string ;
  
  //New Column
  createdIP: string;

 }
export interface AlertList{
  medicineId:string;
  medicineCode? : string;
  pharmaType? : boolean;
  medicineName:string;
  categoryCode:string;
  stockInHand:number;                              
  minQty:number;
  maxQty :number;
  warehouseName:any;
  manufacturer:string;
  genericName:string;
  rack:string;
  branchName: any;
}                             

export abstract class StockListData {
  abstract getById(url: string): Observable<any>;
  abstract list(url: string): Observable<any[]>;
  abstract create(url: string, data: any): Observable<any>;
  abstract update(url: string, data: StockLists): Observable<StockLists>;
  abstract delete(url: string): Observable<any>;
  abstract alertMinList(url:string):Observable<AlertList[]>;
  abstract excessMaxList(url:string):Observable<AlertList[]>;
  abstract stockcreate(url: string, data: any): Observable<any>;
  //StockAdjustment  
  abstract searchList(url: string,data:any): Observable<any>;
  abstract stockAdjustmentcreate(url: string, data: any): Observable<any>;

  //Closing Stock List  
  abstract closingStockList(url: string): Observable<any[]>;

  abstract salesPageOnLoadList(url: string,header:any): Observable<any[]>;

}

